import React, { useState } from 'react';
import { Button, Accordion } from 'carbon-components-react';
import AccordingItem from 'carbon-components-react/lib/components/AccordionItem';
import { FitToScreen16 } from '@carbon/icons-react';
import { PreviewContent } from './localStore/types';
import DOMPurify from 'dompurify';

// const removeStylesAndClass = (ele: Element | null) => {
//   if (ele === null) {
//     return;
//   }
//   ele.removeAttribute('class');
//   ele.removeAttribute('style');
//   if (ele.childElementCount > 0) {
//     for (var i = 0; i < ele.childElementCount; i++) {
//       removeStylesAndClass(ele.children.item(i));
//     }
//   }
// };

const createMarkup = (body: any) => ({
  __html:
    !body.html || body.html === 'false'
      ? DOMPurify.sanitize(body.text_as_html)
      : DOMPurify.sanitize(body.html)
});

const EmailBody: React.FC<Props> = ({
  body,
  isMultiple,
  onPreviewOriginalEmail
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState<boolean>(false);

  return (
    <div className="email-body-container">
      <div
        className={`email-body-full-screen-btn${
          isMultiple && !isAccordionOpen ? ' hidden' : ''
        }`}
      >
        <Button
          kind="tertiary"
          size="field"
          hasIconOnly
          renderIcon={FitToScreen16}
          iconDescription="View in original format"
          tooltipPosition="bottom"
          tooltipAlignment="end"
          onClick={() =>
            onPreviewOriginalEmail({
              type: 'Email',
              title: body?.subject,
              content:
                !body.html || body.html === 'false'
                  ? body.text_as_html
                  : body.html
            })
          }
        />
      </div>
      <div
        className={`email-body-subject${
          isMultiple && !isAccordionOpen ? ' hidden' : ''
        }`}
      >
        {body?.subject}
      </div>
      {isMultiple ? (
        <Accordion>
          <AccordingItem
            title=""
            className="email-body-content"
            onHeadingClick={({ isOpen }) => setIsAccordionOpen(isOpen)}
          >
            <div
              // ref={(el) => {
              //   if (el) {
              //     if (el.childElementCount > 0) {
              //       for (var i = 0; i < el.childElementCount; i++) {
              //         removeStylesAndClass(el.children.item(i));
              //       }
              //     }
              //   }
              // }}
              className="revert-all"
              dangerouslySetInnerHTML={createMarkup(body)}
            />
          </AccordingItem>
        </Accordion>
      ) : (
        <div
          // ref={(el) => {
          //   if (el) {
          //     if (el.childElementCount > 0) {
          //       for (var i = 0; i < el.childElementCount; i++) {
          //         removeStylesAndClass(el.children.item(i));
          //       }
          //     }
          //   }
          // }}
          className="email-body-content revert-all"
          dangerouslySetInnerHTML={createMarkup(body)}
        />
      )}
    </div>
  );
};

type Props = {
  body?: any;
  isMultiple: boolean;
  onPreviewOriginalEmail: (content: PreviewContent | undefined) => void;
};

export default React.memo(EmailBody);
